const dic = JSON.parse(localStorage.dic);
const userInfo = JSON.parse(localStorage.getItem('userInfo'));

export const config = {
  mixins: [],
  data() {
    return {
      columns: []
    };
  },
  methods: {
    // 获取表格列
    getColumns() {
      let columns = [
        {
          type: 'index',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '保单编号',
          slot: 'policyNo',
          align: 'center',
          minWidth: 150,
          fixed: 'left',
        },
        {
          title: '新单缴费状态',
          slot: 'payStatus',
          align: 'center',
          minWidth: 140,
          fixed: 'left'
        },
        {
          title: '保险公司',
          key: 'companyName',
          align: 'center',
          minWidth: 120
        },
        {
          title: '保险产品',
          key: 'productName',
          align: 'center',
          minWidth: 200
        },
        // {
        //   title: '预约编号',
        //   key: 'reservationNo',
        //   align: 'center',
        //   minWidth: 150
        // },
        {
          title: '投保人',
          key: 'name',
          align: 'center',
          minWidth: 100
        },
        {
          title: '受保人',
          key: 'insuranceName',
          align: 'center',
          minWidth: 100
        },
        {
          title: '年缴保费',
          slot: 'fee',
          align: 'center',
          minWidth: 160
        },
        {
          title: '签单日期',
          key: 'signDate',
          align: 'center',
          render(h, params) {
            if (!params.row.signDate) {
              return <span>-</span>;
            } else {
              return <div>{params.row.signDate.split(' ')[0]}</div>;
            }
          },
          minWidth: 120
        },
        {
          title: '保单状态',
          slot: 'status',
          align: 'center',
          minWidth: 160
        },
      ];
      // 全部、已生效、已退保
      if(!this.status || [1, -1].includes(this.status * 1)) {
        columns.push(
          {
            title: '生效日期',
            key: 'effectDate',
            align: 'center',
            render(h, params) {
              if (!params.row.effectDate) {
                return <span>-</span>;
              } else {
                return <div>{params.row.effectDate.split(' ')[0]}</div>;
              }
            },
            minWidth: 120
          },
          {
            title: '冷静期截止日',
            key: 'expirationDate',
            align: 'center',
            render(h, params) {
              if (!params.row.expirationDate) {
                return <span>-</span>;
              } else {
                return <div>{params.row.expirationDate.split(' ')[0]}</div>;
              }
            },
            width: 160
          }
        )
      }
      columns.push(
        {
          title: '归属人',
          key: 'orgName',
          align: 'center',
          render(h, params) {
            return (
              <div>
                {params.row.orgName}
                {params.row.agentName ? '-' + params.row.agentName : ''}
              </div>
            );
          },
          minWidth: 170
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          width: userInfo.showCommission == 1 ? 220 : 170,
          align: 'center'
        }
      )
      this.columns = columns;
    }
  }
};
